// Setup, rules p2. State is plain JSON; the RNG state lives inside it so
// every die that ever falls out of the pyramid is deterministic per seed.

import { createRngState, nextInt, shuffle } from '../rng/rng';
import { emptyTrack } from '../moves';
import {
  CAMELS, LEG_TILE_VALUES, STARTING_MONEY, DIE_MAX, PHASES,
} from '../constants';

export function createGameState({ players, seed }) {
  let rng = createRngState(seed);

  // "the youngest player determines the starting positions ... by taking the
  // 5 Dice and rolling them together" (p2): each camel starts on the space
  // its die shows, stacking in any order - here, a seeded shuffle's order.
  const track = emptyTrack();
  let order;
  [order, rng] = shuffle(CAMELS, rng);
  for (const camel of order) {
    let roll;
    [roll, rng] = nextInt(DIE_MAX, rng);
    track[roll].push(camel); // die value 1..3 -> index 0..2 (flag 1..3)
  }

  const legTiles = {};
  CAMELS.forEach((camel) => { legTiles[camel] = LEG_TILE_VALUES.slice(); });

  return {
    seed,
    rngState: rng,
    players: players.map((p, i) => ({
      ...p,
      seat: i,
      money: STARTING_MONEY,
      // One race betting card per camel for the whole game (p2, "5 Race
      // Betting cards of one character").
      betCards: Object.fromEntries(CAMELS.map((c) => [c, true])),
      legTiles: [], // taken this leg: [{ camel, value }]
      pyramidTiles: 0, // taken this leg
    })),
    track,
    // Dice still in the pyramid this leg; rolled dice sit in the "tents".
    legDice: CAMELS.slice(),
    diceRolled: [], // [{ camel, value }] this leg, in order
    legTiles,
    // Desert tiles by seat: { space, side: 'oasis'|'mirage' } or absent.
    desert: {},
    // Final bets, in placement order - the camel on a card is SECRET until
    // the end (p4, face down); it travels in state but is only ever
    // rendered to its owner, the codenames-key trust level.
    bets: { winner: [], loser: [] },
    turn: {
      activeSeat: 0,
      legStartSeat: 0,
      leg: 1,
    },
    lastRoll: null, // { camel, value } - what the pyramid just produced
    legReport: null, // set at each leg scoring, for the interstitial
    log: [],
    meta: {
      phase: PHASES.PLAYING,
      seq: 0,
      winnerCamel: null,
      loserCamel: null,
      finalReport: null,
    },
  };
}
